import { HTTP_METHOD } from "@nf/constants";
import { IPurchaseResponseModel } from "../models";
import { httpService } from "../../../../services";

export class ProductOfferingService {
  get url(): string {
    return `/v2/store`;
  }

  public getAccountPurchase = (): Promise<IPurchaseResponseModel> =>
    httpService.request<IPurchaseResponseModel>({
      method: HTTP_METHOD.GET,
      url: `${this.url}/account/purchases`,
    });
}
